export default "__VITE_ASSET__CI9m7Cf___"